import { useState, useEffect } from 'react';

const useScreenSize = () => {

  const initialWidth = typeof window === 'undefined' ? 0 : window.innerWidth;
  const initialHeight = typeof window === 'undefined' ? 0 : window.innerHeight;
  
  const [ screenSize, setScreenSize ] = useState({
    width: initialWidth,
    height: initialHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return screenSize;
};

export default useScreenSize;